var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Layout', [_vm.loading || _vm.error ? _c('LoaderIcon', {
    staticClass: "m-auto",
    attrs: {
      "error": _vm.error,
      "error-message": "This referral is no longer available, either because it expired or another MLO was selected.  It has been removed from Network Connect."
    }
  }) : _c('div', [_c('GrayHeader', [_c('MottoBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Network Connect',
        routeName: 'network-connect',
        routeParams: {
          selectedTab: _vm.isOfficeReferral ? 'office_received' : 'received'
        }
      }, {
        label: "Referral - ".concat(_vm.referralIdentifier)
      }],
      "back-route": 'network-connect',
      "back-route-params": {
        selectedTab: _vm.isOfficeReferral ? 'office_received' : 'received'
      }
    }
  }), _c('BaseTitle', {
    staticClass: "gray-header-title"
  }, [_vm._v("Referral - " + _vm._s(_vm.referralIdentifier))]), _c('p', {
    staticClass: "d-block d-lg-none mt-3 color-secondary-light-blue"
  }, [_vm._v(" " + _vm._s(_vm.getStatusTooltipText(_vm.referral.officeReceivedStatus || _vm.referral.receivedStatus)) + " ")])], 1), _c('FormItemGroup', [_c('FormItem', {
    attrs: {
      "label": "Subject Property Address State",
      "value": _vm.referral.state
    }
  }), _c('FormItem', {
    attrs: {
      "label": "Loan Type",
      "value": _vm.referral.loanType
    }
  }), _c('FormItem', {
    attrs: {
      "label": "Loan Amount",
      "value": _vm.referral.loanAmount
    }
  })], 1), _c('FormItemGroup', [_c('FormItem', {
    attrs: {
      "label": "Date Received",
      "value": _vm.referral.receivedAtStr
    }
  }), _c('div', {
    staticClass: "position-relative d-flex"
  }, [_c('FormItem', {
    attrs: {
      "label": "Status",
      "value": _vm.referral.officeReceivedStatus || _vm.referral.receivedStatus
    }
  }), _vm.getStatusTooltipText(_vm.referral.officeReceivedStatus || _vm.referral.receivedStatus) ? _c('Tooltip', {
    class: _vm.$style.statusTooltip,
    attrs: {
      "target": "".concat(_vm.referral.id),
      "placement": "top",
      "theme": "blue"
    }
  }, [_vm._v(" " + _vm._s(_vm.getStatusTooltipText(_vm.referral.officeReceivedStatus || _vm.referral.receivedStatus)) + " ")]) : _vm._e()], 1), _c('div')], 1), _vm.referral.receivedStatus === 'Completed' ? _c('FormItemGroup', [_c('FormItem', {
    attrs: {
      "label": "Sender Name",
      "value": _vm.referral.createdBy.name
    }
  }), _c('FormItem', {
    attrs: {
      "label": "Sender Motto Email",
      "value": _vm.referral.createdBy.email
    },
    scopedSlots: _vm._u([{
      key: "afterValue",
      fn: function fn() {
        return [_vm.referral.receivedStatus === 'Completed' ? _c('a', {
          class: _vm.$style.contactIcon,
          attrs: {
            "href": "mailto:".concat(_vm.referral.createdBy.email, "?subject=Completed ").concat(_vm.referral.state || '', " ").concat(_vm.referral.loanType || '', " deal level referral")
          }
        }, [_c('MottoIcon', {
          staticClass: "ml-2",
          attrs: {
            "id": "envelope".concat(_vm.referral.id),
            "name": "Envelope",
            "icon-color": "orange"
          }
        }), _c('b-tooltip', {
          attrs: {
            "target": "envelope".concat(_vm.referral.id),
            "placement": "top",
            "custom-class": "tooltipBlue"
          }
        }, [_vm._v(" Email referrer ")])], 1) : _vm._e()];
      },
      proxy: true
    }], null, false, 2392173594)
  }), _c('FormItem', {
    attrs: {
      "label": "Sender Work line",
      "value": _vm.referral.createdBy.phone
    },
    scopedSlots: _vm._u([{
      key: "afterValue",
      fn: function fn() {
        return [_vm.referral.receivedStatus === 'Completed' ? _c('a', {
          class: _vm.$style.contactIcon,
          attrs: {
            "href": "tel:".concat(_vm.referral.createdBy.phone)
          }
        }, [_c('MottoIcon', {
          staticClass: "ml-2",
          attrs: {
            "id": "phone".concat(_vm.referral.id),
            "name": "Phone",
            "icon-color": "orange"
          }
        }), _c('b-tooltip', {
          attrs: {
            "target": "phone".concat(_vm.referral.id),
            "placement": "top",
            "custom-class": "tooltipBlue"
          }
        }, [_vm._v(" Call referrer’s work line ")])], 1) : _vm._e()];
      },
      proxy: true
    }], null, false, 2506285839)
  })], 1) : _vm._e(), _vm.referral.officeUsers && _vm.referral.officeUsers.length ? _c('div', [_c('div', {
    staticClass: "position-relative"
  }, [_c('p', {
    staticClass: "p1 mt-10 mb-10 color-dark-gray"
  }, [_vm._v("Assigned Users")]), _c('p', {
    staticClass: "p1 color-dark-gray",
    class: _vm.$style.recipientResponseText
  }, [_vm._v("Status:")]), _c('div', {
    class: _vm.$style.searchResultsContainer
  }, _vm._l(_vm.referral.officeUsers.map(function (item) {
    return Object.assign({}, item, {
      recipientType: 'user'
    });
  }), function (user) {
    return _c('SearchRecipientResult', {
      key: user.id,
      attrs: {
        "recipient": user,
        "disabled": ""
      },
      scopedSlots: _vm._u([{
        key: "actionButton",
        fn: function fn() {
          return [_c('div', {
            class: _vm.$style.selectButtonContainer
          }, [_c('p', {
            staticClass: "text-align-left p1 color-dark-gray"
          }, [_vm._v(" " + _vm._s(user.receivedStatus) + " ")])])];
        },
        proxy: true
      }], null, true)
    });
  }), 1)])]) : _vm._e(), _vm.referral.receivedStatus === 'Pending Assignment' ? _c('div', [_c('p', {
    staticClass: "p1 mt-10 mb-10 color-dark-gray"
  }, [_vm._v("Assign an MLO:")]), _c('div', {
    class: _vm.$style.searchResultsContainer
  }, _vm._l(_vm.officeMlos.map(function (item) {
    return Object.assign({}, item, {
      recipientType: 'user'
    });
  }), function (mlo) {
    return _c('SearchRecipientResult', {
      key: mlo.id,
      attrs: {
        "recipient": mlo,
        "disabled": ""
      },
      scopedSlots: _vm._u([{
        key: "actionButton",
        fn: function fn() {
          return [_c('BaseButton', {
            staticClass: "mr-3",
            attrs: {
              "options": {
                defaultPadding: true
              },
              "theme": "green",
              "disabled": _vm.disableAcceptanceButtons
            },
            on: {
              "click": function click($event) {
                return _vm.acceptMlo(mlo);
              }
            }
          }, [_vm._v(" Assign ")])];
        },
        proxy: true
      }], null, true)
    });
  }), 1)]) : _vm._e(), _vm.referral.receivedStatus === 'Open' && !_vm.isOfficeReferral || _vm.referral.receivedStatus === 'Pending Assignment' ? _c('div', {
    class: _vm.$style.bottomButtonsContainer
  }, [_c('BaseButton', {
    attrs: {
      "options": {
        defaultPadding: true
      },
      "theme": "red",
      "disabled": _vm.disableAcceptanceButtons
    },
    on: {
      "click": function click($event) {
        return _vm.declineReferral(_vm.referral);
      }
    }
  }, [_vm._v(" Decline ")]), _vm.referral.receivedStatus !== 'Pending Assignment' ? _c('BaseButton', {
    attrs: {
      "options": {
        defaultPadding: true
      },
      "theme": "green",
      "disabled": _vm.disableAcceptanceButtons
    },
    on: {
      "click": function click($event) {
        return _vm.acceptReferral(_vm.referral);
      }
    }
  }, [_vm._v(" Accept ")]) : _vm._e()], 1) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }